import { createServerFn } from "@tanstack/react-start";

import { requireSupabaseAuth } from "@/integrations/supabase/auth-middleware";
import { assertAdmin } from "@/lib/admin-guard.server";
import type { SitePricingResult } from "@/lib/pricing-types";

/** Publika priser och villkor från skolsystemet – används av hela sajten. */
export const getSitePricing = createServerFn({ method: "GET" }).handler(
  async (): Promise<SitePricingResult> => {
    const { loadSitePricing } = await import("@/lib/pricing-source.server");
    const { loadTermSettings } = await import("@/lib/term-settings.server");
    const [result, termSettings] = await Promise.all([loadSitePricing(), loadTermSettings()]);
    return { ...result, termSettings };
  },
);

/** Tvingar en ny hämtning från skolsystemet och skriver om cachen. */
export const refreshSitePricing = createServerFn({ method: "POST" })
  .middleware([requireSupabaseAuth])
  .handler(async ({ context }): Promise<SitePricingResult> => {
    await assertAdmin(context as never, "/admin/priser");
    const { loadSitePricing } = await import("@/lib/pricing-source.server");
    const { invalidateCached } = await import("@/lib/server-cache");
    invalidateCached("site-pricing");
    const { loadTermSettings, invalidateTermSettings } = await import("@/lib/term-settings.server");
    invalidateTermSettings();
    const [result, termSettings] = await Promise.all([loadSitePricing(true), loadTermSettings()]);
    return { ...result, termSettings };
  });
